import { render, staticRenderFns } from "./PurchaseQrcode.vue?vue&type=template&id=420dad37&"
import script from "./PurchaseQrcode.vue?vue&type=script&lang=js&"
export * from "./PurchaseQrcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports